module.exports = __webpack_public_path__ + "img/cloth_g1_hat_01.58d15d80.svg";